<ion-header>
    <ion-toolbar>
        <ion-title>Add Contact</ion-title>
        <ion-buttons slot="start">
            <ion-button (click)="modalController.dismiss()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-card>
        <ion-input type="text" placeholder="Contact name" [(ngModel)]="contact.name" maxlength="20"></ion-input>
        <ion-input type="tel" placeholder="Phone" [(ngModel)]="contact.phone"></ion-input>
        <ion-input type="email" placeholder="Email" [(ngModel)]="contact.email"></ion-input>

        <ion-fab vertical="bottom" horizontal="end" >
            <ion-fab-button (click)="saveContact()" color="success">
                <ion-icon name="checkmark"></ion-icon>
            </ion-fab-button>
        </ion-fab>

    </ion-card>
</ion-content>
